var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("wes-message", _vm._b({}, "wes-message", _vm.messagePanel, false)),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.data !== null,
              expression: "data !== null",
            },
          ],
        },
        [
          _c("div", { attrs: { id: "pivotgrid" } }),
          _vm._v(" "),
          _c("div", { attrs: { id: "pivotgrid-popup" } }),
          _vm._v(" "),
          _c("ui-table-modal", { attrs: { tituloModal: "Analítico" } }, [
            _c(
              "div",
              { attrs: { slot: "body" }, slot: "body" },
              [
                _c("ui-data-table", {
                  attrs: { dataObject: this.dataObjectTable },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }